import { create } from 'zustand';

interface PaginationStore {
    beforeCursor: string;
    setBeforeCursor: (obj: string) => void;

    afterCursor: string;
    setAfterCursor: (obj: string) => void;

    limit: number;
    setLimit: (obj: number) => void;

    reQuery: boolean;
    setReQuery: (obj: boolean) => void;

    pageAction: boolean;
    setPageAction: (obj: boolean) => void;

    resetStore: () => void;
    closeAction: () => void;
}

const usePaginationStore = create<PaginationStore>((set) => ({
    beforeCursor: '',
    setBeforeCursor: (obj) => set({ beforeCursor: obj }),

    afterCursor: '',
    setAfterCursor: (obj) => set({ afterCursor: obj }),

    limit: 5,
    setLimit: (obj) => set({ limit: obj }),

    reQuery: false,
    setReQuery: (obj) => set({ reQuery: obj }),

    pageAction: false,
    setPageAction: (obj) => set({ pageAction: obj }),

    resetStore: () => set({
        beforeCursor: '',
        afterCursor: '',
        limit: 5,
        reQuery: false,
        pageAction: false,
    }),

    closeAction: () => set({
        reQuery: false,
        pageAction: false,
    })
}));

export default usePaginationStore;
